var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loaded
    ? _c(
        "div",
        {
          staticClass: "bg-cover",
          class: this.sidebar ? "sidebar-open" : null,
          style:
            _vm.backgroundImage() && _vm.isPrePostLive()
              ? _vm.backgroundImage()
              : null,
          attrs: { id: "app" },
        },
        [
          _vm.asset && _vm.backgroundVideo() && _vm.isPrePostLive()
            ? _c(
                "video",
                {
                  staticClass: "bg-video",
                  attrs: {
                    autoplay: "",
                    loop: "",
                    muted: "",
                    playsinline: "",
                    "webkit-playsinline": "",
                  },
                  domProps: { muted: true },
                },
                [
                  _c("source", {
                    attrs: {
                      src: _vm.backgroundVideo(),
                      type: _vm.genFileType(),
                    },
                  }),
                ]
              )
            : _vm._e(),
          _c("Header"),
          _c("router-view", { key: _vm.$route.fullPath, staticClass: "main" }),
          _c("Footer"),
        ],
        1
      )
    : _vm.error
    ? _c("Error", { attrs: { error: _vm.error } })
    : _c("Loading")
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }